export const NavigationLabel = ({ date }: { date: Date }): JSX.Element => {
  return (
    <div className="month-with-suffix">
      <span className="month-number">{date.getMonth() + 1}</span>
      <span className="month-suffix">月</span>
    </div>
  );
};
